import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Modal } from 'react-bootstrap';
import { ArrowRight } from 'lucide-react';
import NumberFormat from 'react-number-format';
import SSN from '../../Shared/common/components/Shared_FormControls/SSN/SSN';
import Modalpopup from '../../Shared/Modals/Modal';
import CustomRadioButton from '../../Shared/common/components/Shared_FormControls/CustomRadioButton/CustomRadioButton';
import Phone from "../../Shared/common/components/Shared_FormControls/PhoneNumberField/PhoneNumberField";
import Email from "../../Shared/common/components/Shared_FormControls/Email/Email";
import TextBox from "../../Shared/common/components/Shared_FormControls/TextBox/TextBox";
import { convertToSSNFormat, decrypt } from '../../../commonservices/CommonMethods';
import ConfirmationPopup from '../../Shared/common/components/Modalpopups/ConfirmationPopup/ConfirmationPopup';

const PrincipalInformation = (props) => {

    const [showConfirmationToContinue, setShowConfirmationToContinue] = useState(false);
    const [isNextClicked, setIsNextClicked] = useState(false);

    const [dealerPrincipals, setDealerPrincipals] = useState([{

        firstName: "",
        lastName: "",
        ownership: "",
        email: "",
        dealershipPhoneNumber: "",
        ssn: ""

    }]);

    useEffect(() => {

        if (props.principalInformationDetails && props.principalInformationDetails.dealerPrincipal && props.principalInformationDetails.dealerPrincipal.length > 0 && props.principalInformationDetails.dealerPrincipal[0].isPrepopulate) {

            const data = props.principalInformationDetails.dealerPrincipal[0];

            setDealerPrincipals([{

                firstName: data.firstName ? data.firstName : '',
                lastName: data.lastName ? data.lastName : '',
                email: data.email ? data.email : '',
                ownership: data.ownership ? data.ownership : '',
                dealershipPhoneNumber: data.dealershipPhoneNumber ? data.dealershipPhoneNumber : '',
                ssn: data.ssn && data.ssn.length > 11 ? decrypt(data.ssn) : data.ssn,
                isPrepopulate: data.isPrepopulate ? data.isPrepopulate : false,

            }]);

        }
        else if (props.principalInformationDetails && props.principalInformationDetails.dealerPrincipal && props.principalInformationDetails.dealerPrincipal.length > 0) {
            setDealerPrincipals(props.principalInformationDetails.dealerPrincipal);
        }
        else {
            setDealerPrincipals([{

                firstName: "",
                lastName: "",
                ownership: "",
                email: "",
                dealershipPhoneNumber: "",
                ssn: "",

            }])
        }

    }, [props.principalInformationDetails.dealerPrincipal]);

    const twoWayBind = (key, value, index) => {

        if (key === 'ownership')
            value = value.replace(/[^0-9]/g, '');

        const data = JSON.parse(JSON.stringify(dealerPrincipals))
        data[index][key] = value;

        setDealerPrincipals(data);

    }

    const addDealerPrincipal = (index) => {

        setDealerPrincipals([
            ...dealerPrincipals,
            {

                firstName: "",
                lastName: "",
                ownership: "",
                email: "",
                dealershipPhoneNumber: "",
                ssn: ""

            }
        ])

    }

    const deleteDealerPrincipal = (index) => {

        let data = JSON.parse(JSON.stringify(dealerPrincipals))
        data = data.filter((item, itemIndex) => itemIndex != (index + 1));
        setDealerPrincipals(data);

    }

    const processToNextStep = () => {



        setIsNextClicked(true);

        for (let dealerPrincipal of dealerPrincipals) {

            for (let key in dealerPrincipal) {

                if (['isPrepopulate', 'isEquifaxError'].includes(key))
                    continue;
                else if (key === 'dealershipPhoneNumber' && (!dealerPrincipal[key] || (dealerPrincipal[key] && dealerPrincipal[key].length !== 10)))
                    return;
                else if (key === 'ssn' && (!dealerPrincipal[key] || (dealerPrincipal[key] && dealerPrincipal[key].length !== 9)))

                    return;
                else if (!dealerPrincipal[key])
                    return;

            }

        }

        dealerPrincipals.forEach(item => {
            item.isPrepopulate = false;
        })

        props.twoWayBind('dealerPrincipal', dealerPrincipals);
        setShowConfirmationToContinue(true);
    }

    return (
        <div className='onboarding-form-box-modal'>
            <h1 className='mb-3'>Principal Information</h1>
            <p className='mb-3'>All principals owning over 10% must be added</p>

            {
                dealerPrincipals.map((item, index) => {

                    const checkVariables = dealerPrincipals[index + 1] || isNextClicked;

                    return (<div className='from-wrapper'>

                        <Form.Row className="two-fields-row">
                            <Form.Group as={Col} controlId="formBasicFN">
                                <TextBox
                                    required
                                    label="Dealer Principal Name"
                                    name="Dealer Principal Name"
                                    value={item.firstName}
                                    objectKey="firstName"
                                    placeholder="Dealer Principal Name"
                                    onChange={(key, value) => twoWayBind(key, value, index)}
                                />
                                {/* <Form.Label className="label-color">Dealer Principal Name</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={item.firstName}
                                    className="content-text-13px"
                                    onChange={(event) => twoWayBind('firstName', event.target.value, index)}
                                    style={{ borderColor: (checkVariables && !item.firstName ? '#A10F0F' : null) }}
                                />*/}
                                {checkVariables && !item.firstName ? <span className='input-error-message'>Please enter valid Dealer First Name.</span> : null}
                            </Form.Group>
                            <Form.Group as={Col} controlId="formBasicFN">
                                <TextBox
                                    required
                                    label="Last Name"
                                    name="Last Name"
                                    value={item.lastName}
                                    objectKey="lastName"
                                    placeholder="Last Name"
                                    onChange={(key, value) => twoWayBind(key, value, index)}
                                />
                                {/* <Form.Label className="label-color"></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={item.lastName}
                                    className="content-text-13px"
                                    onChange={(event) => twoWayBind('lastName', event.target.value, index)}
                                    style={{ borderColor: (checkVariables && !item.lastName ? '#A10F0F' : null) }}
                                />*/}
                                {checkVariables && !item.lastName ? <span className='input-error-message'>Please enter valid Dealer Last Name.</span> : null}
                            </Form.Group>
                            <Form.Group controlId="formBasicFN">
                                <TextBox
                                    required
                                    label="% Ownership of Dealer Entity"
                                    name="% Ownership of Dealer Entity"
                                    value={item.ownership}
                                    objectKey="ownership"
                                    placeholder="% Ownership of Dealer Entity"
                                    onChange={(key, value) => twoWayBind(key, value, index)}
                                />
                                {/* <Form.Label className="label-color">% Ownership of Dealer Entity</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    name="dealerentity"
                                    placeholder="Ownership"
                                    value={item.ownership}
                                    className="content-text-13px"
                                    onChange={(event) => twoWayBind('ownership', event.target.value, index)}
                                    style={{ borderColor: (checkVariables && !item.ownership ? '#A10F0F' : null) }}
                                />*/}
                                {checkVariables && !item.ownership ? <span className='input-error-message'>Please enter valid Dealer Ownership.</span> : null}
                            </Form.Group>
                            <Form.Group controlId="formBasicFN">
                                <Email
                                    required
                                    label="Email Address"
                                    name="Email"
                                    objectKey="email"
                                    placeholder="Email Address"
                                    value={item.email}
                                    onChange={(key, value) => twoWayBind(key, value, index)}
                                />
                                {/* <Form.Label className="label-color">Email Address</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    name="email"
                                    placeholder="Email Address"
                                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                                    value={item.email}
                                    className="content-text-13px"
                                    onChange={(event) => twoWayBind('email', event.target.value ? event.target.value.toLowerCase() : '', index)}
                                    style={{ borderColor: (checkVariables && !item.email ? '#A10F0F' : null) }}
                                /> */}
                                {checkVariables && !item.email ? <span className='input-error-message'>Please enter valid Dealer Email.</span> : null}
                            </Form.Group>
                            <Form.Group controlId="formBasicFN">
                                <Phone
                                    required
                                    label="Cell Phone Number"
                                    name="Cell Phone Number"
                                    objectKey="dealershipPhoneNumber"
                                    placeholder="(000) 000-0000"
                                    value={item.dealershipPhoneNumber}
                                    onChange={(key, value) => twoWayBind(key, value, index)}
                                />
                                {/* <Form.Label className="label-color">Cell Phone Number</Form.Label>
                                <NumberFormat
                                    className='content-text-13px form-control'
                                    name="dealerphone"
                                    placeholder="(000) 000-0000"
                                    format='(###) ###-####'
                                    value={item.dealershipPhoneNumber}
                                    onValueChange={(values) => twoWayBind('dealershipPhoneNumber', values.value, index)}
                                    style={{ borderColor: (checkVariables && (!item.dealershipPhoneNumber || (item.dealershipPhoneNumber && item.dealershipPhoneNumber.length !== 10)) ? '#A10F0F' : null) }}
                                />*/}
                                {checkVariables && (!item.dealershipPhoneNumber || (item.dealershipPhoneNumber && item.dealershipPhoneNumber.length !== 10)) ? <span className='input-error-message'>Please enter valid Cell Phone Number.</span> : null}
                            </Form.Group>
                            <Form.Group controlId="formBasicFN">
                                <SSN
                                    required
                                    label="SSN"
                                    name="SSN"
                                    objectKey="ssn"
                                    placeholder="000-00-0000"
                                    value={convertToSSNFormat(item.ssn)}
                                    onChange={(key, value) => twoWayBind(key, value, index)}
                                />
                                {/* <Form.Label className="label-color">SSN</Form.Label>
                                <NumberFormat
                                    className='content-text-13px form-control'
                                    name="dealerphone"
                                    placeholder="000-00-0000"
                                    format='###-##-####'
                                    value={convertToSSNFormat(item.ssn)}
                                    onValueChange={(values) => twoWayBind('ssn', values.value, index)}
                                    style={{ borderColor: (checkVariables && (!item.ssn || (item.ssn && item.ssn.length !== 9)) ? '#A10F0F' : null) }}
                                />*/}
                                {checkVariables && (!item.ssn || (item.ssn && item.ssn.length !== 9)) ? <span className='input-error-message'>Please enter valid SSN.</span> : null}
                            </Form.Group>
                        </Form.Row>
                        <b className='d-block mb-3'>Is there an additional dealer principal?</b>
                        <Form.Row className='mx-0'>
                            <Form.Group className='mr-3'>
                                <CustomRadioButton
                                    label="Yes"
                                    name="Yes"
                                    checked={dealerPrincipals[index + 1] ? true : false}
                                    onChange={(key, value) => addDealerPrincipal(index)} />
                                {/* <span className='d-flex mr-2'>
                                    <Form.Check
                                        type="radio"
                                        aria-label="radio 1"
                                        checked={dealerPrincipals[index + 1] ? true : false}
                                        onChange={() => addDealerPrincipal(index)}
                                    />
                                    <Form.Label>Yes</Form.Label>
                                </span> */}
                            </Form.Group>
                            <Form.Group>
                                <CustomRadioButton
                                    label="No"
                                    name="No"
                                    checked={!dealerPrincipals[index + 1] ? true : false}
                                    onChange={(key, value) => deleteDealerPrincipal(index)} />
                                {/* <span className='d-flex'>
                                    <Form.Check
                                        type="radio"
                                        aria-label="radio 2"
                                        checked={!dealerPrincipals[index + 1] ? true : false}
                                        onChange={() => deleteDealerPrincipal(index)}
                                    />
                                    <Form.Label>No</Form.Label>
                                </span> */}
                            </Form.Group>
                        </Form.Row>
                    </div>)

                })

            }

            <Form.Row className="mx-0 align-items-center">
                <Col className='p-0'>
                    <Button className="default-btn" type="button" onClick={() => processToNextStep()} variant="primary">Next</Button>
                </Col>
            </Form.Row>

            {/* <Modalpopup myClassName='add-supplire-popup add-auction-details' onClose={() => setShowConfirmationToContinue(false)} showModal={showConfirmationToContinue} >
                <Modal.Body className="pl-3 pr-3">
                    <h4 style={{ textAlign: 'center', marginTop: '7px' }}>Confirmation</h4>
                    <hr />
                    <div style={{ textAlign: 'center' }}>
                        <h6>Do you want to add additional dealer principals?</h6>
                        <Button onClick={() => setShowConfirmationToContinue(false)} style={{ margin: '10px 3px' }}>Yes</Button>
                        <Button onClick={(event) => { setShowConfirmationToContinue(false); props.submit(event, null, false, true); }} style={{ margin: '10px 3px' }}>No</Button>
                    </div>
                </Modal.Body>
            </Modalpopup> */}
            <ConfirmationPopup
                title="Do you want to add additional dealer principals?"
                onClose={() => setShowConfirmationToContinue(false)}
                showModal={showConfirmationToContinue}
                showPopupLoader={false}
                primaryActionLabel="Yes"
                secondaryActionLabel="No"
                primaryAction={() => setShowConfirmationToContinue(false)}
                secondaryAction={(event) => { setShowConfirmationToContinue(false); props.submit(event, null, false, true); }}
            />
        </div>
    )
}

export default PrincipalInformation;